var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mr-4 relative w-20 h-10 bg-gray-300 rounded-full cursor-pointer transition-colors duration-300",
    class: {
      'bg-gray-300 ': _vm.isEnglish
    },
    on: {
      "click": _vm.toggleLang
    }
  }, [_c('div', {
    staticClass: "absolute top-1 left-1 w-8 h-8 bg-primary-600 rounded-full shadow-md transform transition-transform duration-300",
    class: _vm.isEnglish ? 'translate-x-10' : 'translate-x-0'
  }), _c('div', {
    staticClass: "absolute inset-0 flex items-center justify-between px-3 text-sm font-bold text-white"
  }, [_c('span', {
    class: {
      'text-gray-600': _vm.isEnglish
    }
  }, [_vm._v("ID")]), _c('span', {
    class: {
      'text-gray-600': !_vm.isEnglish
    }
  }, [_vm._v("EN")])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }